module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/hero_mob-49575bf256a7e8ee9da888b89152c904.jpg";